import InboxMembersAPI from '../../api/inboxMembers';

export const actions = {
  get(_, { inboxId }) {
    return InboxMembersAPI.show(inboxId);
  },
  create(_, { inboxId, agentList, teamList = [] }) {
    return InboxMembersAPI.update({ inboxId, agentList, teamList });
  },
};

export default {
  namespaced: true,
  actions,
};
